import { defineMessages, useIntl } from 'react-intl';
const legacyMessages = defineMessages({
    normal: {
        defaultMessage: 'Normal',
        id: '7635624bdb',
        description: 'Normal speed option in the Computer effort slider',
    },
    normalDescription: {
        defaultMessage: 'Normal credit usage',
        id: 'df0651b3dd',
        description: 'Description for the Normal speed option in the Computer effort slider',
    },
    fast: {
        defaultMessage: 'Fast',
        id: '6510d70e9d',
        description: 'Fast speed option in the Computer effort slider',
    },
    fastDescription: {
        defaultMessage: 'Increased credit usage',
        id: '29a2028f9d',
        description: 'Description for the Fast speed option in the Computer effort slider',
    },
});
export function getComputerSpeedOptions(config) {
    if (config?.speed_options != null) {
        return config.speed_options.filter((option) => option.speed === 'standard' || option.speed === 'fast' || option.speed === 'ultrafast');
    }
    // Old catalogs and Standard-only rows omit options; keep their legacy selection behavior.
    const model = config?.model ?? config?.non_reasoning_model;
    if (!model)
        return [];
    const options = [
        {
            speed: 'standard',
            model,
            label: legacyMessages.normal,
            description: legacyMessages.normalDescription,
        },
    ];
    if (config?.fast_model) {
        options.push({
            speed: 'fast',
            model: config.fast_model,
            label: legacyMessages.fast,
            description: legacyMessages.fastDescription,
        });
    }
    return options;
}
export function getModelConfigIds(config) {
    const variants = config.speed_options != null
        ? [config.non_reasoning_model, ...getComputerSpeedOptions(config).map(({ model }) => model)]
        : [config.non_reasoning_model, config.reasoning_model, config.fast_model];
    return [...new Set(variants.filter((model) => model != null))];
}
export function getModelOptionLabel({ config, model, legacyLabels, }) {
    if (config?.speed_options == null)
        return legacyLabels.join(', ') || undefined;
    const option = getComputerSpeedOptions(config).find((option) => option.model === model);
    return option?.speed !== 'standard' ? option?.label : undefined;
}
export function useSpeedOptionText() {
    const { $t } = useIntl();
    return (text) => {
        if (text == null)
            return '';
        return typeof text === 'string' ? text : $t(text);
    };
}
//# sourceMappingURL=computerSpeedOptions.js.map